import { isCCApp } from '../../api/api';
import { getClientLogoUrl } from '../../utils/utils';

export const setApplicationLanguage = (
  state = '',
  { type = '', payload } = {},
) => {
  switch (type) {
    case 'SET_APPLICATION_LANGUAGE':
      return payload;
    default:
      return state;
  }
};

export const setLogo = (
  state = {},
  { type = '', payload: { data = {}, status = '' } = {} } = {},
) => {
  switch (type) {
    case 'SET_LOGO':
      if (isCCApp() && getClientLogoUrl() !== '' && data) {
        // eslint-disable-next-line
        data.url = getClientLogoUrl();
      }
      if (status === 200) {
        return data;
      }
      return state;
    default:
      return state;
  }
};

export const setGlobalMenu = (
  state = [],
  { type = '', payload: { data = {}, status = '' } = {} } = {},
) => {
  switch (type) {
    case 'SET_GLOBAL_MENU':
      if (status === 200) {
        return data;
      }
      return state;
    case 'SET_ACTIVE_GLOBAL_MENU_ITEM':
      if (status === 200) {
        return state.map(({ isActive, ...item }) => ({
          ...item,
          ...(item.id === data ? { isActive: true } : {})
        }));
      }
      return state;
    default:
      return state;
  }
};

export const setClientColors = (
  state = {},
  { type = '', payload: { data = {}, status = '' } = {} } = {},
) => {
  switch (type) {
    case 'SET_CLIENT_COLORS':
      if (status === 200) {
        return data;
      }
      return state;
    default:
      return state;
  }
};

export const setFooter = (
  state = [],
  { type = '', payload: { data = {}, status = '' } = {} } = {},
) => {
  switch (type) {
    case 'FOOTERLINKS':
      if (status === 200) {
        return data;
      }
      return state;
    default:
      return state;
  }
};

export const setAlertsCount = (
  state = 0,
  { type = '', payload: { data = {}, status = '' } = {} } = {},
) => {
  switch (type) {
    case 'ALERTS_COUNT':
      if (status === 200) {
        return data;
      }
      return state;
    default:
      return state;
  }
};

export const setGenericAlerts = (
  state = [],
  { type = '', payload: { data = {}, status = '' } = {} } = {},
) => {
  switch (type) {
    case 'GENERIC_ALERTS':
      if (status === 200) {
        return data;
      }
      return state;
    default:
      return state;
  }
};

export const setReceiveAlerts = (
  state = [],
  { type = '', payload: { data = {}, status = '' } = {} } = {},
) => {
  switch (type) {
    case 'RECEIVE_ALERTS':
      if (status === 200) {
        return [].concat(data);
      }
      return state;
    default:
      return state;
  }
};

export const setActivity = (
  state = [],
  { type = '', payload: { data = {}, status = '' } = {} } = {},
) => {
  switch (type) {
    case 'ACTIVITY_MENU':
      if (status === 200) {
        return data;
      }
      return state;
    default:
      return state;
  }
};

export const setWidgetEnabled = (
  state = false,
  { type = '', payload: { data = false, status = '' } = {} } = {},
) => {
  switch (type) {
    case 'HAS_WIDGET_ENABLED':
      if (status === 200) {
        return data;
      }
      return state;
    default:
      return state;
  }
};

export const setRefreshAuthToken = (
  state = false,
  { type = '', payload: { data = {}, status = '' } = {} } = {},
) => {
  switch (type) {
    case 'REFRESH_AUTH_TOKEN':
      if (status === 200) {
        return data;
      }
      return state;
    default:
      return state;
  }
};

export const setSessionExtendDialog = (
  state = false,
  { type = '', payload: { data = {}, status = '' } = {} } = {},
) => {
  switch (type) {
    case 'SET_SESSION_EXTEND_DIALOG':
      if (status === 200) {
        return Object.assign({}, data);
      }
      return state;
    default:
      return state;
  }
};

export const setCartLink = (
  state = '',
  { type = '', payload: { data = '', status = '' } = {} } = {},
) => {
  switch (type) {
    case 'CART_LINK':
      if (status === 200) {
        return ''.concat(data);
      }
      return state;
    default:
      return state;
  }
};

export const setCatalogLink = (
  state = '',
  { type = '', payload: { data = '', status = '' } = {} } = {},
) => {
  switch (type) {
    case 'CATALOG_LINK':
      if (status === 200) {
        return data;
      }
      return state;
    default:
      return state;
  }
};

export const setBankCatalog = (
  state = [],
  { type = '', payload: { data = '', status = '' } = {} } = {},
) => {
  switch (type) {
    case 'BANKS_CATALOG':
      if (status === 200) {
        return data;
      }
      return state;
    default:
      return state;
  }
};

export const setCustomerName = (
  state = [],
  { type = '', payload: { data = '', status = '' } = {} } = {},
) => {
  switch (type) {
    case 'CUSTOMER_NAME':
      if (status === 200) {
        return data;
      }
      return state;
    default:
      return state;
  }
};

export const setAwards = (
  state = [],
  { type = '', payload: { data = {}, status = '' } = {} } = {},
) => {
  switch (type) {
    case 'AWARDS':
      if (status === 200) {
        return data;
      }
      return state;
    default:
      return state;
  }
};

export const setCatalogs = (
  state = [],
  { type = '', payload: { data = {}, status = '' } = {} } = {},
) => {
  switch (type) {
    case 'CATALOGS':
      if (status === 200) {
        return data;
      }
      return state;
    default:
      return state;
  }
};

export const setTasksCount = (
  state = [],
  { type = '', payload: { data = {}, status = '' } = {} } = {},
) => {
  switch (type) {
    case 'TASKS_COUNT':
      if (status === 200) {
        return Object.assign({}, data);
      }
      return state;
    default:
      return state;
  }
};

export const setLogout = (
  state = [],
  { type = '', payload: { data = {}, status = '' } = {} } = {},
) => {
  switch (type) {
    case 'LOGOUT':
      if (status === 200) {
        return data;
      }
      return state;
    default:
      return state;
  }
};

export const setGreeting = (
  state = '',
  { type = '', payload: { data = {}, status = '' } = {} } = {},
) => {
  switch (type) {
    case 'GREETING':
      if (status === 200) {
        return data;
      }
      return state;
    default:
      return state;
  }
};

export const setContextMenu = (
  state = [],
  { type = '', payload: { data = {}, status = '' } = {} } = {},
) => {
  switch (type) {
    case 'SET_CONTEXT_MENU':
      if (status === 200) {
        return data;
      }
      return state;
    default:
      return state;
  }
};

export const setCurrentApplication = (
  state = '',
  { type = '', payload: { data = '', status = '' } = {} } = {},
) => {
  switch (type) {
    case 'SET_CURRENT_APPLICATION':
      if (status === 200) {
        return data;
      }
      return state;
    default:
      return state;
  }
};

export const setTranslations = (
  state = {},
  { type = '', payload: { data = {}, status = '' } = {} } = {},
) => {
  switch (type) {
    case 'TRANSLATIONS_UPDATED':
      if (status === 200) {
        return data;
      }
      return state;
    default:
      return state;
  }
};

const combinedReducer = {
  applicationLanguage: setApplicationLanguage,
  logo: setLogo,
  activity: setActivity,
  hasGivenWidgetEnabled: setWidgetEnabled,
  cartLink: setCartLink,
  catalogLink: setCatalogLink,
  banks: setBankCatalog,
  globalMenu: setGlobalMenu,
  contextMenu: setContextMenu,
  clientColors: setClientColors,
  currentApplication: setCurrentApplication,
  footer: setFooter,
  alertsCount: setAlertsCount,
  genericAlerts: setGenericAlerts,
  receiveAlerts: setReceiveAlerts,
  awards: setAwards,
  catalogs: setCatalogs,
  logout: setLogout,
  greeting: setGreeting,
  translations: setTranslations,
  tasksCount: setTasksCount,
  sessionExtendDialog: setSessionExtendDialog,
  refreshAuthToken: setRefreshAuthToken,
  customerName: setCustomerName
};

const rootReducer = (oldState = {}, { type = '', payload } = {}) =>
  Object.keys(combinedReducer).reduce(
    (state, key) => ({
      ...state,
      [key]: combinedReducer[key](state[key], { type, payload })
    }),
    oldState,
  );

export default rootReducer;
